import { Box, Checkbox, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { ModalGeneric } from 'components/modal/ModalGeneric'
import Pagination from 'components/Pagination/Pagination'
import environment from 'constants/apiConst'
import { useGlobalContext } from 'context/GlobalContext'
import React, { useContext, useEffect, useState } from 'react'
import { isArray } from 'utils/type-check-utils'
import bro from "../../../../assets/bro.png";
import { RxCross2 } from 'react-icons/rx'
import { IconGeneric } from 'styled/Icons.styled'
import { HeaderSearch } from 'styled/SectionContainer.styled'
import { Title } from 'styled/Title'
import FormCrudCRUDContext from 'context/FormCrudContex'
import { ButtonStyled } from 'styled/Buttons.styled'
import { useSearchParams } from 'react-router-dom'
import Swal from 'sweetalert2'
import { AlertErrorAlert } from 'components/Alerts/AlertErrorAlert'
import queryEnv from 'constants/queryConst'

const theadReentry = [
  { name: "N° Item", order: null },
  { name: "Referencia", order: null },
  { name: "Descripción", order: null },
  { name: "Cantidad", order: null },
  { name: "Unidad comercial", order: null },
  { name: "Añadir", order: null }
]

const theadReentrySelected = [
  { name: "N° Item", order: null },
  { name: "Referencia", order: null },
  { name: "Descripción", order: null },
  { name: "Cantidad", order: null },
  { name: "Eliminar", order: null }
]

const AddItemsReentryOperation = ({ dataFetch, isOpen, onOpen, onClose }) => {
  const [params] = useSearchParams();
  const {
    update, setUpdate,
    isSelectedAllItems, setIsSelectedAllItems,
    itemsSelected, setItemsSelected,
    onCloseSelectAuthorizationItems,
  } = useContext(FormCrudCRUDContext);

  const [page, setPage] = useState(1);
  const [pageItemsSelected, setPageItemsSelected] = useState(1);
  const [localSelectedItems, setLocalSelectedItems] = useState([]);
  const [editedQuantities, setEditedQuantities] = useState({}); // { [itemId]: number|string }

  const { requestData } = useGlobalContext();
  const queryClient = useQueryClient();
  const [openAlert] = AlertErrorAlert();

  // Query para obtener los items
  const { data: dataItemsReentry, isLoading } = useQuery({
    queryKey: ['itemsReentry', dataFetch, page],
    queryFn: () => requestData({
      Endpoint: environment.GET_ITEMS_TEMPORARY_ENTRY_FORM,
      method: 'POST',
      page,
      data: {
        ...dataFetch,
        length: 5
      },
    }),
  });



  const itemsArray = React.useMemo(() => {
    const responseData = dataItemsReentry?.data?.status?.data;
    const items = responseData?.data;
    if (!items || !Array.isArray(items)) return [];
    return items;
  }, [dataItemsReentry?.data?.status?.data]);

  // Mutation para agregar items
  const { mutate } = useMutation({
    mutationFn: requestData,
    retry: 3,
    onSuccess: data => {
      if (data?.data?.status?.code === 400) {
        return openAlert(data?.data?.status?.message, 'error');
      }
      if (data?.data?.status?.code === 200) {
        setLocalSelectedItems([]);
        setIsSelectedAllItems(false);
        setUpdate(prev => !prev);
        onClose();
        queryClient.invalidateQueries({ queryKey: [queryEnv?.SUPPLIES_CI] });
        openAlert(data?.data?.status?.message, 'success');
      }
    }
  });

  // Actualiza cantidad editada por item
  const updateEditedQuantity = (itemId, value) => {
    setEditedQuantities(prev => ({ ...prev, [itemId]: value }));
    // Si ya está seleccionado, reflejar el cambio en la selección
    setLocalSelectedItems(prev => prev.map(it =>
      it?.item === itemId ? { ...it, quantity_product: value } : it
    ));
  };

  // Función simple para manejar selección de items (usa cantidad editada si existe)
  const handleItemSelection = (item, isSelected) => {
    if (isSelected) {
      const overrideQty = editedQuantities[item?.item] ?? item?.quantity_product;
      const normalized = { ...item, quantity_product: overrideQty };
      setLocalSelectedItems(prev => {
        const exists = prev.some(i => i?.item === item?.item);
        if (exists) return prev.map(i => i?.item === item?.item ? normalized : i);
        return [...prev, normalized];
      });
    } else {
      setLocalSelectedItems(prev => prev.filter(i => i?.item !== item?.item));
    }
  };

  // Función para seleccionar todos los items
  const handleSelectAll = async (e) => {
    const isChecked = e.target.checked;
    setIsSelectedAllItems(isChecked);

    if (isChecked) {
      try {
        const response = await queryClient.fetchQuery({
          queryKey: ['itemsReentryALL', dataFetch],
          queryFn: () => requestData({
            Endpoint: environment.GET_ITEMS_TEMPORARY_ENTRY_FORM,
            method: 'POST',
            page: 1,
            data: {
              ...dataFetch,
              length: 1000
            },
          }),
          staleTime: 0
        });

        const allItemsData = response?.data?.status?.data?.data || [];

        if (Array.isArray(allItemsData) && allItemsData.length > 0) {
          const allItemsNormalized = allItemsData
            .filter(item => item?.aggregated !== 1)
            .map(item => ({
              ...item,
              quantity_product: editedQuantities[item?.item] ?? item?.quantity_product
            }));

          setLocalSelectedItems(allItemsNormalized);
        }
      } catch (error) {
        console.error("Error obteniendo todos los items:", error);
      }
    } else {
      setLocalSelectedItems([]);
    }
  };

  // Función para eliminar item de selección
  const removeItem = (item) => {
    setLocalSelectedItems(prev => prev.filter(i => i?.item !== item?.item));
  };

  // Función para enviar datos
  const handleSubmit = () => {
    if (params?.get('FormEntryNumber')) {
      return Swal.fire({
        title: '¿Deseas agregar los items seleccionados?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, agregar',
        didOpen: () => {
          // Forzamos el z-index del contenedor de esta alerta especifica
          const container = Swal.getContainer();
          if (container) container.style.zIndex = '20000';
        }
      }).then((result) => {
        if (result.isConfirmed) {
          mutate({
            data: {
              ...dataFetch,
              array_item: localSelectedItems.filter(i => i?.aggregated !== 1).map(i => i),
              all_item: isSelectedAllItems,
            },
            Endpoint: environment.ADD_TEMPORAL_ITEM_ONFORM,
            PropertyBody: 'POST',
          });
        }
      });
    }
    setItemsSelected(localSelectedItems);
    onClose();
  };

  // Manejar paginación de items seleccionados
  useEffect(() => {
    if (pageItemsSelected !== 1 && localSelectedItems.slice((pageItemsSelected - 1) * 5, pageItemsSelected * 5).length === 0) {
      setPageItemsSelected(pageItemsSelected - 1);
    }
  }, [localSelectedItems, pageItemsSelected]);

  return (
    <ModalGeneric
      isOpen={isOpen}
      onClose={onClose}
      onOpen={onOpen}
      title="Seleccionar Items"
      size="5xl"
    >
      <HeaderSearch>
        <Box display="flex" justifyContent="space-between" mb="10px">
          <Title size="18px">Items de la Salida</Title>
          <Box display="flex" gap="0.1rem" mr="20px" alignItems="center" justifyContent="end">
            <h1 style={{ fontSize: '14px', marginRight: '10px' }}>
              Seleccionar todos los items
            </h1>
            <Checkbox
              bgColor="#fff"
              borderRadius="10px"
              colorScheme="white"
              iconColor="blue.400"
              size="md"
              isChecked={isSelectedAllItems}
              onChange={handleSelectAll}
            />
          </Box>
        </Box>

        <TableReentryOperation
          thead={theadReentry}
          data={itemsArray}
          loading={isLoading}
          onItemSelect={handleItemSelection}
          selectedItems={localSelectedItems}
          tbodyData={TBodyReentryOperationItems}
          editedQuantities={editedQuantities}
          onQtyChange={updateEditedQuantity}
        />

        <Pagination
          page={page}
          setPage={setPage}
          maxPage={dataItemsReentry?.data?.status?.data?.last_page || 1}
          loading={isLoading}
        />
      </HeaderSearch>

      {isArray(localSelectedItems) && localSelectedItems?.length !== 0 && (
        <HeaderSearch>
          <Title>Items seleccionados</Title>
          <TableReentryOperation
            thead={theadReentrySelected}
            data={localSelectedItems.slice((pageItemsSelected - 1) * 5, pageItemsSelected * 5) || []}
            loading={isLoading}
            onItemRemove={removeItem}
            tbodyData={TBodyReentryOperationItemsSelected}
            editedQuantities={editedQuantities}
            onQtyChange={updateEditedQuantity}
            messageNoData="No hay items seleccionados"
          />
          <Pagination
            page={pageItemsSelected}
            setPage={setPageItemsSelected}
            maxPage={Math.ceil(localSelectedItems.length / 5) || 1}
          />
        </HeaderSearch>
      )}

      <Box display="flex" justifyContent="end" mt="20px" gap="10px">
        <ButtonStyled
          bgColor="#bababa"
          onClick={() => {
            onCloseSelectAuthorizationItems();
            setIsSelectedAllItems(false);
            setLocalSelectedItems([]);
            onClose();
          }}
        >
          Cancelar
        </ButtonStyled>
        <ButtonStyled onClick={handleSubmit}>
          Aceptar
        </ButtonStyled>
      </Box>
    </ModalGeneric>
  )
}

export default AddItemsReentryOperation

// Componente simplificado para mostrar items disponibles
const TBodyReentryOperationItems = ({ data, onItemSelect, selectedItems, editedQuantities, onQtyChange }) => {
  const isSelected = selectedItems.some(item => item?.item === data?.item);
  const isDisabled = data?.aggregated === 1;
  const itemId = data?.item;
  const displayQty = editedQuantities?.[itemId] ?? data?.quantity_product ?? '';

  const handleQtyInputChange = (e) => {
    const val = e.target.value;
    const maxValue = Number(data?.quantity_product) || 0;
    const numericValue = parseFloat(val);

    // Si el valor es mayor al máximo, no actualizar
    if (!isNaN(numericValue) && numericValue > maxValue) {
      return;
    }

    onQtyChange(itemId, val);
  };

  return (
    <Tr>
      <Td className="text-center">{data?.item || ""}</Td>
      <Td className="text-center">{data?.reference || ""}</Td>
      <Td className="text-center">{data?.description_product || ""}</Td>
      <Td className="text-center">
        <input
          type="number"
          min={0}
          max={Number(data?.quantity_product) || undefined}
          value={displayQty}
          onChange={handleQtyInputChange}
          style={{ width: '80px', textAlign: 'center' }}
          disabled={isDisabled}
        />
      </Td>
      <Td className="text-center">{data?.code_businessUnit || ""}</Td>
      <Td className="text-center">
        <Checkbox
          bgColor="#fff"
          borderRadius="10px"
          colorScheme="white"
          isChecked={isSelected || isDisabled}
          iconColor="blue.400"
          onChange={(e) => !isDisabled && onItemSelect({ ...data, quantity_product: editedQuantities?.[itemId] ?? data?.quantity_product }, e.target.checked)}
          isDisabled={isDisabled}
        />
      </Td>
    </Tr>
  )
}

// Componente simplificado para mostrar items seleccionados
const TBodyReentryOperationItemsSelected = ({ data, onItemRemove, editedQuantities, onQtyChange }) => {
  const itemId = data?.item;
  const displayQty = editedQuantities?.[itemId] ?? data?.quantity_product ?? '';

  const handleQtyInputChange = (e) => {
    const val = e.target.value;
    const maxValue = Number(data?.quantity_product) || 0;
    const numericValue = parseFloat(val);

    // Si el valor es mayor al máximo, no actualizar
    if (!isNaN(numericValue) && numericValue > maxValue) {
      return;
    }

    onQtyChange(itemId, val);
  };
  return (
    <Tr>
      <Td className="text-center">{data?.item || ""}</Td>
      <Td className="text-center">{data?.reference || ""}</Td>
      <Td className="text-center">{data?.description_product || ""}</Td>
      <Td className="text-center">
        <input
          type="number"
          min={0}
          max={Number(data?.quantity_product) || undefined}
          value={displayQty}
          onChange={handleQtyInputChange}
          style={{ width: '80px', textAlign: 'center' }}
        />
      </Td>
      <Td className="text-center">
        <IconGeneric
          onClick={() => onItemRemove(data)}
          color="red"
          cursor="pointer"
          width="16px"
          as={RxCross2}
        />
      </Td>
    </Tr>
  )
}

// Componente simplificado para la tabla
const TableReentryOperation = ({ thead, data, isLoading, onItemSelect, onItemRemove, selectedItems, tbodyData: TBodyData, messageNoData, editedQuantities, onQtyChange }) => {
  return (
    <Table
      size="md"
      variant="simple"
      className="table table-sm"
      overflowX={true}
      __css={{ minH: "300px" }}
    >
      <Thead borderBottom="2px solid #1f7ac3">
        {thead.map((th, index) => (
          <Th p={1} key={th?.name + "_" + index} className="text-center">
            {th.name}
          </Th>
        ))}
      </Thead>
      <Tbody className="table-hover">
        {(isLoading || !isArray(data) || (isArray(data) && data?.length === 0)) ? (
          <Tr>
            <Td colSpan={thead.length}>
              {!messageNoData && (
                <div className="d-flex justify-content-center ml-6">
                  <img
                    style={{ width: "20%" }}
                    src={window.assetURL + bro}
                    alt="no hay formulario"
                  />
                </div>
              )}
              <h2 className="text-center my-2">{messageNoData || "Aún no hay registros."}</h2>
            </Td>
          </Tr>
        ) : (
          data?.map((item, index) => (
            <TBodyData
              key={`item-${item?.item || index}`}
              data={item}
              onItemSelect={onItemSelect}
              onItemRemove={onItemRemove}
              selectedItems={selectedItems}
              editedQuantities={editedQuantities}
              onQtyChange={onQtyChange}
            />
          ))
        )}
      </Tbody>
    </Table>
  )
}